// Mock data for WEGTECH site

export const mockSubmitContactForm = async (formData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log('Form submitted (MOCK):', formData);
  
  // Store in localStorage for demo purposes
  const existingContacts = JSON.parse(localStorage.getItem('wegtech_contacts') || '[]');
  const newContact = {
    ...formData,
    id: Date.now(),
    timestamp: new Date().toISOString()
  };
  existingContacts.push(newContact);
  localStorage.setItem('wegtech_contacts', JSON.stringify(existingContacts));
  
  return {
    success: true,
    message: 'Mensagem enviada com sucesso! Entraremos em contato em breve.'
  };
};

export const servicesData = [
  {
    id: 1,
    title: 'Cibersegurança',
    description: 'Proteção 24/7 firewalls SOC LGPD',
    icon: 'Shield',
    details: 'Monitoramento contínuo, firewall de última geração, SOC dedicado e conformidade total com LGPD para proteger seus dados corporativos.'
  },
  {
    id: 2,
    title: 'Networking',
    description: 'Redes enterprise switches Wi-Fi',
    icon: 'Network',
    details: 'Infraestrutura de rede enterprise com switches gerenciáveis, Wi-Fi corporativo e conectividade de alta performance para sua empresa.'
  },
  {
    id: 3,
    title: 'Pentest',
    description: 'Testes penetração vulnerabilidades',
    icon: 'Bug',
    details: 'Testes de penetração especializados para identificar vulnerabilidades antes que sejam exploradas, com relatórios detalhados e recomendações.'
  },
  {
    id: 4,
    title: 'Infraestrutura',
    description: 'Servidores cloud backups',
    icon: 'Server',
    details: 'Gestão completa de servidores físicos e cloud, backups automatizados e redundância para garantir continuidade do seu negócio.'
  },
  {
    id: 5,
    title: 'Revenda Hardware/Software',
    description: 'Equipamentos enterprise atendimento premium',
    icon: 'Package',
    details: 'Fornecimento de equipamentos e licenças enterprise das principais marcas do mercado com atendimento personalizado e suporte dedicado.'
  }
];

export const companyInfo = {
  name: 'WEGTECH',
  phone: '+5527920014773',
  email: 'contato@wegtech.com.br',
  address: 'Travessa São Benedito 10, Cariacica - ES',
  whatsappLink: 'https://wa.me/5527920014773'
};